import React from 'react';
import { Card, CardContent } from './ui/card';
import { Gem, Target, Lightbulb, Heart, Award, ThumbsUp, Building, TrendingUp } from 'lucide-react';
import { whyChooseUs, stats } from '../data/mock';

const iconMap = {
  Gem: Gem,
  Target: Target,
  Lightbulb: Lightbulb,
  Heart: Heart,
  Award: Award,
  ThumbsUp: ThumbsUp,
  Building: Building,
  TrendingUp: TrendingUp
};

const About = () => {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#0f172a] mb-4">
            Why Choose <span className="text-[#d4af37]">Pringle Construction</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Setting the standard for excellence in residential and commercial construction
          </p>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20">
          {stats.map((stat) => {
            const IconComponent = iconMap[stat.icon];
            return (
              <div 
                key={stat.id} 
                className="text-center group cursor-pointer"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#d4af37]/10 rounded-full mb-4 group-hover:bg-[#d4af37]/20 transition-colors duration-300">
                  <IconComponent className="text-[#d4af37]" size={28} />
                </div>
                <div className="text-4xl font-bold text-[#0f172a] mb-2 group-hover:text-[#d4af37] transition-colors duration-200">
                  {stat.value}
                </div>
                <div className="text-gray-600 font-medium">{stat.label}</div>
              </div>
            );
          })}
        </div>

        {/* Why Choose Us Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyChooseUs.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <Card 
                key={item.id} 
                className="group hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-[#d4af37]/30 bg-white"
              >
                <CardContent className="p-6 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#d4af37]/20 to-[#d4af37]/5 rounded-full mb-4 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="text-[#d4af37]" size={28} />
                  </div>
                  <h3 className="text-xl font-bold text-[#0f172a] mb-3 group-hover:text-[#d4af37] transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Company Description */}
        <div className="mt-20 max-w-4xl mx-auto">
          <Card className="bg-gradient-to-br from-[#0f172a] to-[#1a1f3a] border-none shadow-2xl">
            <CardContent className="p-8 md:p-12">
              <h3 className="text-3xl font-bold text-white mb-6">
                Building Your Vision with <span className="text-[#d4af37]">Precision</span>
              </h3>
              <p className="text-gray-300 text-lg leading-relaxed mb-6">
                For over 25 years, Pringle Construction LLC has been at the forefront of luxury construction, 
                delivering exceptional residential and commercial projects that stand as testaments to our 
                unwavering commitment to quality and innovation.
              </p>
              <p className="text-gray-300 text-lg leading-relaxed">
                Our team of experienced professionals combines traditional craftsmanship with cutting-edge 
                technology to transform your vision into reality. From initial concept to final completion, 
                we ensure every detail exceeds expectations and every project becomes a lasting legacy.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default About;
